// components/YearSelect.jsx
import React from 'react';
import Select from 'react-select';

const YearSelect = ({
    value,
    onChange,
    recentYear,
    childId,
    field,
    onBlur,
    customOptions,
}) => {
    const currentYear = parseInt(recentYear);
    const yearOptions =
        // customOptions
        // ? customOptions.map((y) => ({ value: y, label: y }))
        // :
Array.from({ length: 13 }, (_, i) => {
            const year = currentYear - 12 + i;
            return { value: year.toString(), label: year.toString() };
        });

    const handleChange = (selected) => {
        if (childId && field) {
            onChange(childId, field, selected?.value);
        } else {
            onChange(selected?.value);
        }
    };

    return (
        <Select
            options={yearOptions}
            // value={
            //     yearOptions.find((y) => y.value === value) ||
            //     yearOptions.find((y) => y.value === new Date().getFullYear().toString())
            // }
            // value={
            //     value
            //       ? yearOptions.find((y) => y.value === value)
            //       : null // ✅ This ensures the "Select" placeholder shows
            //   }
            value={
                yearOptions.find((y) => y.value === (value || currentYear.toString()))
              }
              
            onChange={handleChange}
            // onBlur={onBlur} 
             onBlur={() =>
                childId && field ? onBlur(childId, field) : onBlur
            }
            placeholder="Select"
            styles={{
                control: (base) => ({
                    ...base,
                    border: "none",
                    borderBottom: "1px solid #23674b",
                    borderRadius: 0,
                    paddingLeft: "0.5rem",
                    fontSize:"20px",
                    minWidth: "8ch",
                    fontWeight: 'bold',
                    color: '#23674b',
                    boxShadow: "none",
                    outline: "none",
                    '&:hover': {
                        borderBottom: "1px solid #23674b",
                    },
                }),
                singleValue: (base) => ({
                    ...base,
                    color: '#23674b',
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                }),
            }}
            classNamePrefix="yearselect"
        />
    );
};

export default YearSelect;
